import { DeviceMeta, GameLauncher } from 'Roblox';
import { jsClientDeviceIdentifier, authenticatedUser } from 'header-scripts';
import { urlService } from 'core-utilities';
import gameDataUtil from '../../gameData/utils/gameDetailMetaData';

const { isIE11 } = jsClientDeviceIdentifier;
const { getCurrentGameMetaData } = gameDataUtil;

const { deviceType, isUWPApp, isInApp } = DeviceMeta();
export const getPlaceIdFromUrl = () => {
  return +window.location.pathname.split('/')[2];
};

const shouldUseGameLaunchInterface = () => {
  return (
    (deviceType === 'computer' && !isUWPApp) || (deviceType === 'tablet' && isIE11) || isUWPApp
  );
};
export const getJoinScript = (placeId, { instanceId, accessCode }) => {
  if (shouldUseGameLaunchInterface()) {
    return () => {
      // accessCode must be checked first in the case of joining a live private server instance
      if (accessCode) {
        GameLauncher.joinPrivateGame(placeId, accessCode);
        return;
      }

      if (instanceId) {
        GameLauncher.joinGameInstance(placeId, instanceId);
      }
    };
  }
  let url = '';
  if (isInApp) {
    url = urlService.getUrlWithQueries('/games/start', { placeId });
  } else {
    url = `robloxmobile://placeID=${placeId}`;
  }
  if (instanceId) {
    url += `&gameInstanceId=${instanceId}`;
  }

  if (accessCode) {
    url += `&accessCode=${accessCode}`;
  }
  return () => {
    window.location.href = url;
  };
};

export const canCreatePrivateGameServer = servers => {
  let { gameDetailPrivateServerLimit } = getCurrentGameMetaData();
  servers.forEach(({ owner }) => {
    if (owner.id === authenticatedUser.id) {
      gameDetailPrivateServerLimit -= 1;
    }
  });
  return gameDetailPrivateServerLimit > 0;
};
